module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_intro"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_table"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Genealogical Tables")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I: Antipater")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_chap01"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" Rise to Power")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_chap02"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Alexander’s Lieutenant")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Macedonian Governor I – Thrace and Agis")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" Macedonian Governor II – Surviving Alexander")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" The Lamian War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Triparadeisos")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" The Problems of Empire")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II: Kassander")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" Kassander to Power")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" Kassander, Lord of Macedon")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" King Kassander")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" A Ruling Dynasty’s End")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part III: The Later Family")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" Three Grandsons")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")])]), _vm._v(" Three Daughters")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")])]), _vm._v(" The Last of the Dynasty")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conclusion: A Brief but Effective Dynasty")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_abb",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes and References")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0